/*
 * PRD-037 — App SEPARADA del portal del partner. Router + auth propios; NO importa el
 * AuthContext/router/axiosInstance del panel. Se monta desde src/index.tsx para rutas
 * /partner y /pre-registro. Reusa partnerService (standalone) y, en el draft, el smart menu.
 */
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { PartnerAuthProvider, usePartnerAuth } from './PartnerAuthContext';
import PartnerLogin from './pages/PartnerLogin';
import PartnerPortal from './pages/PartnerPortal';
import PartnerDraftMenu from './pages/PartnerDraftMenu';
import ClaimPage from './pages/ClaimPage';

const PortalGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerPortal /> : <PartnerLogin />;
};

const DraftGate = () => {
  const { token } = usePartnerAuth();
  return token ? <PartnerDraftMenu /> : <Navigate to="/partner" replace />;
};

const router = createBrowserRouter([
  { path: '/pre-registro/:token', element: <ClaimPage /> },
  { path: '/partner', element: <PortalGate /> },
  { path: '/partner/draft/:id/menu', element: <DraftGate /> },
  { path: '*', element: <Navigate to="/partner" replace /> },
]);

const PartnerApp = () => (
  <PartnerAuthProvider>
    <RouterProvider router={router} />
  </PartnerAuthProvider>
);

export default PartnerApp;
